<template>
  <div>
    <RecordNotFound v-if="status_code == 404" :message="status_message"></RecordNotFound>
    <div class="PriceList-create-page" v-else>
      <!--  credit form component -->
      <PriceListForm
        :page="$route.params.id ? 'update' : 'create'"
        :submitted="submitted"
        :duplicatecode="duplicatecode"
        v-on:FormUpdate="FormUpdate = 1"
        v-on:onSubmit="onSubmit($event)"
      ></PriceListForm>
    </div>
  </div>
</template>

<script>
import PriceListForm from "@/components/Form/PriceList/PriceListForm"; // credit form for create and update
import store from "@/store/index"; // vuex store fucntion
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import { mapState } from "vuex"; // get data set in the state in vuex
import RecordNotFound from "@/pages/Error/RecordNotFound";

export default {
  name: "PriceListCreate",
  mixins: [notificationMixin], // call the glbal mixin fucntion
  components: {
    PriceListForm,
    RecordNotFound
  },
  data() {
    return {
      FormUpdate: 0,
      duplicatecode: false,
      submitted: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center" // notification design class
    };
  },
  methods: {
    onSubmit(ev) {
      this.submitted = true;
      var data = ev.data;
      this.$store
        .dispatch("pricinglist/createList", data)
        .then(() => {
          this.FormUpdate = 0; // to hide before route leave confirmation message
          if (this.status_code == 200) {
            if (this.$store.state.pricinglist.pricelist_index_history) {
              this.$router.push(
                this.$store.state.pricinglist.pricelist_index_history
              );
            } else {
              this.$router.push({ name: "PriceList" });
            }
          } else {
            this.submitted = false;
            this.duplicatecode = true;
          }
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.status_message,
            type: this.status_type,
            showCloseButton: true
          });
        })
        .catch(() => {});
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store.dispatch("pricinglist/fetchPriceListDetails").then(() => {
      next();
    });
  },
  beforeRouteLeave(routeTo, routeFrom, next) {
    //  alert message before leaving route to confirm unsave the changes
    if (this.FormUpdate == 1) {
      //  alert message to confirm
      const answer = window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
      //  if okay move to next route
      if (answer) {
        next();
      } else {
        //  stay on the page
        next(false);
      }
    } else {
      //  move to the route if they had not done any changes
      next();
    }
  },
  updated: function() {},
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapState({
      code: state => state.pricinglist.code,
      message: state => state.pricinglist.message, // to show any error nessage occurs
      updated_id: state => state.pricinglist.updated_id,
      status_code: state => state.pricinglist.status_code,
      status_message: state => state.pricinglist.status_message,
      status_type: state => state.pricinglist.status_type
    })
  }
};
</script> 

<style>
</style>
